import React, { useState } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Header from "./Header";
import Footer from "./Footer";
import HeadingNavbar from "./HeadingNavbar";
import firebaseApp from "./fireconnect";
import { toast, ToastContainer } from "react-toastify";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { fullName, phone, message } = formData;

    const phoneRegex = /^[6789]\d{9}$/;

    if (!phoneRegex.test(phone)) {
      toast.error("Please enter a valid 10-digit phone number.");
      return;
    }

    if (!fullName || !phone || !message) {
      toast.error("Please fill in all the fields.");
      return;
    }

    const db = firebaseApp.firestore();

    try {
      await db.collection("ContactFormSubmissions").add({
        fullName,
        phone,
        message,
        createdAt: new Date(),
      });

      toast.success("Form submitted successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      setFormData({
        fullName: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting form: ", error);
      toast.error(
        "There was an error submitting your form. Please try again.",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    }
  };

  return (
    <div>
      <HeadingNavbar />
      <Header name="contact" />
      <section className="pb-35 pt-35">
        <div className="container request-form p-4">
          <div className="row justify-content-center">
            <div className="col-md-12 pt-30x">
              <h2 className="mb-20">Contact Us</h2>
              <p>
                Have questions about our water filtration solutions or need help
                with a product? Our team at Bliss Water Technology is here to
                assist you. Get in touch with us, and we will respond as soon as
                possible.
              </p>
            </div>
            <div className="col-md-12 m-autox text-start">
              <form onSubmit={handleSubmit}>
                <div className="row mt-30 mb-10">
                  <div className="col-md-6">
                    <label htmlFor="fullName">Full Name</label>
                    <input
                      type="text"
                      id="fullName"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      maxLength={10}
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>
                </div>

                <div className="row pb-20">
                  <div className="col-12">
                    <label htmlFor="message">Message</label>
                    <textarea
                      name="message"
                      id="message"
                      rows="5"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      className="form-control"
                    ></textarea>
                  </div>
                </div>

                <div className="row pt-0 pb-30">
                  <div className="col">
                    <p className="mt-10 mb-10">
                      The personal information collected is processed by Bliss
                      Water Technology for the purpose of handling your
                      inquiries and providing the best support possible.
                    </p>
                    <div className="mt-4 d-flex align-items-center">
                      <button className="productOrderBtn" type="submit">
                        <span className="productOrderBtnSpan">Submit</span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <ToastContainer />
    </div>
  );
};

export default ContactUs;
